import React, { useContext } from "react";
import { MyContext } from "../Context/MyContext";
import "./SearchBar.css";

export default function SearchBar() {
  const { filters, setSearch, header } = useContext(MyContext);
  const placeholder = header?.search?.placeholder || "Search cars...";

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder={placeholder}
        value={filters.search || ""}
        onChange={(e) => setSearch(e.target.value)}
      />
      <span className="search-icon">🔍</span>
    </div>
  );
}
